function checkRadioField(input, checked)
{

    let disabled = input.hasAttr("disabled");
    let container = input.closest(".inp-radio-wrap");

    if (disabled) {
        container.addClass(("disabled"));
        if (checked) {
            container.find("checked-disabled").removeClass("displ-none");
            container.find("unchecked-disabled").addClass("displ-none");
            container.addClass("checked");
        } else {
            container.find("checked-disabled").addClass("displ-none");
            container.find("unchecked-disabled").removeClass("displ-none");
        }
    } else {
        if (checked) {
            container.find(".checked").removeClass("displ-none");
            container.find(".unchecked").addClass("displ-none");
            container.addClass("checked");

            let siblings = container.closest(".radios-list").find('input[name="' + input.attr("name") + '"]').not(input).closest(".inp-radio-wrap");

            siblings.find(".checked").addClass("displ-none");
            siblings.find(".unchecked").removeClass("displ-none");
            siblings.removeClass("checked");

        } else {
            container.find(".checked").addClass("displ-none");
            container.find(".unchecked").removeClass("displ-none");
        }
    }

}

function checkCheckboxField(input, checked)
{

    let disabled = input.hasAttr("disabled");
    let container = input.closest(".inp-checkbox-wrap");

    if (disabled) {
        container.addClass(("disabled"));
        if (checked) {
            container.find(".checked-disabled").siblings().addClass("displ-none");
            container.find(".checked-disabled").removeClass("displ-none");
            container.addClass("checked");
        } else {
            container.find(".unchecked-disabled").siblings().addClass("displ-none");
            container.find(".unchecked-disabled").removeClass("displ-none");
            container.removeClass("checked");
        }
    } else {
        if (checked) {
            container.find(".checked").siblings().addClass("displ-none");
            container.find(".checked").removeClass("displ-none");
            container.addClass("checked");
        } else {
            container.find(".unchecked").siblings().addClass("displ-none");
            container.find(".unchecked").removeClass("displ-none");
            container.removeClass("checked");
        }
    }
}

const MySelectBox = function (select) {

    let selectBox = select;
    let dropDownWrapper = null;
    let dropDownObject;

    let optionsTexts = [];
    let options = [];
    let selectedOptions = {};

    let selOptions = selectBox.get(0).options;
    Array.from(selOptions).forEach(
        function (element, key, array) {
            optionsTexts[key] = array[key].text;
            options[key] = array[key];
            if (array[key].selected) {
                selectedOptions[key] = array[key];
            }
        }
    );

    let settings = {
        defaultPromptText: 'Vyberte možnost',
        multiple: isDefined(select.attr('multiple')),
        type: "dropdown",
        search: false,
        dropDownAreaRender: function () {
            return '<div class="selected-options"></div>';
        },
        optionRender: function (option) {
            return '<div class="flex-box flex-align-justify"><span>' + option.text + '</span></div>';
        },
        selectedOptionRender: function (option) {
            return '<div class="flex-box flex-align-justify"><span>' + option.text + '</span></div>';
        },
        searchMinLength: 3,
        ajaxHandle: null
    };

    Object.defineProperties(this, {
        selectBox: {
            get: function () {
                return selectBox;
            }
        },
        dropDownWrapper: {
            get: function () {
                return dropDownWrapper;
            },
            set: function (dropDownWrapperObj) {
                if (isObject(dropDownWrapperObj)) {
                    dropDownWrapper = dropDownWrapperObj;
                }
            }
        },
        dropDownObject: {
            get: function () {
                return dropDownObject;
            }
        },
        defaultPromptText: {
            get: function () {
                return settings.defaultPromptText;
            },
            set: function (defaultPromptText) {
                settings.defaultPromptText = defaultPromptText;
            }
        },
        multiple: {
            get: function () {
                return settings.multiple;
            },
            set: function (multiple) {
                if (isBoolean(multiple)) {
                    settings.multiple = multiple;
                    selectBox.prop('multiple', true);
                }
            }
        },
        type: {
            get: function () {
                return settings.type;
            },
            set: function (type) {
                settings.type = type;
            }
        },
        search: {
            get: function () {
                return settings.search;
            },
            set: function (search) {
                if (isBoolean(search)) {
                    settings.search = search;
                }
            }
        },
        optionRender: {
            get: function () {
                return settings.optionRender;
            },
            set: function (optionRender) {
                if (isFunction(optionRender)) {
                    settings.optionRender = optionRender;
                }
            }
        },
        selectedOptionRender: {
            get: function () {
                return settings.selectedOptionRender;
            },
            set: function (selectedOptionRender) {
                if (isFunction(selectedOptionRender)) {
                    settings.selectedOptionRender = selectedOptionRender;
                }
            }
        },
        dropDownAreaRender: {
            get: function () {
                return settings.dropDownAreaRender;
            },
            set: function (dropDownAreaRender) {
                if (isFunction(dropDownAreaRender)) {
                    settings.dropDownAreaRender = dropDownAreaRender;
                }
            }
        },
        optionsTexts: {
            get: function () {
                return optionsTexts;
            }
        },
        options: {
            get: function () {
                return options;
            }
        },
        selectedOptions: {
            get: function () {
                return selectedOptions;
            }
        },
        searchMinLength: {
            get: function () {
                return settings.searchMinLength;
            },
            set: function (searchMinLength) {
                settings.searchMinLength = parseInt(searchMinLength);
            }
        },
        ajaxHandle: {
            set: function (ajaxHandle) {
                if (isFunction(ajaxHandle)) {
                    settings.ajaxHandle = ajaxHandle;
                }
            }
        }
    });

    this.loadAjaxData = function (searchTerm, callback) {
        let self = this;
        settings.ajaxHandle(searchTerm, function (jsonOptions) {

            if (isDefined(jsonOptions)) {

                self.options.forEach(function (option, i) {
                    if (!option.selected) {
                        option.remove();
                    }
                });

                if (Object.entries(jsonOptions).length) {
                    dropDownWrapper.find('.not-found').hide();
                    for (let [value, text] of Object.entries(jsonOptions)) {
                        if (options[value] === undefined) {
                            let newOption = new Option(text, value);
                            selectBox.get(0).add(newOption);
                        }
                    }
                } else {
                    dropDownWrapper.find('.not-found').show();
                }

                optionsTexts = [];
                options = [];

                let selOptions = selectBox.get(0).options;
                Array.from(selOptions).forEach(
                    function (element, key, array) {
                        optionsTexts[array[key].value] = array[key].text;
                        options[array[key].value] = array[key];
                        if (array[key].selected) {
                            selectedOptions[array[key].value] = array[key];
                        }
                    }
                );

                callback(true);
            }
        });
    };

    this.ajaxHandleIsSet = function () {
        return settings.ajaxHandle != null;
    };

    this.setDropDownObject = function (dropDownObj) {
        dropDownObject = dropDownObj;
    };

};

MySelectBox.prototype.updateSelect = function () {

    let self = this;

    this.options.forEach(function (option, i) {
        if (self.selectedOptions[i] === undefined) {
            option.removeAttribute('selected');
        }
    });

    for (let [i, option] of Object.entries(this.selectedOptions)) {
        if (option.value !== '') {
            option.setAttribute('selected', 'selected');
        } else {
            option.removeAttribute('selected');
        }
    }

};

MySelectBox.prototype.renderSelectedOptions = function () {

    let areaContent = '';
    let selectedOptions = Object.entries(this.selectedOptions);
    let selectedOptionsCount = Object.keys(this.selectedOptions).length;

    let dropDownArea = this.dropDownWrapper.find('.drop-down-area');

    let self = this;
    if (selectedOptions.length) {

        let optionClasses = '';
        let optionCss = '';

        if (selectedOptionsCount > 1 || this.multiple) {
            for (let [i, option] of selectedOptions) {

                if (option.getAttribute('class') !== null) {
                    optionClasses = option.getAttribute('class');
                }

                if (option.getAttribute('style') !== null) {
                    optionCss = option.getAttribute('style');
                }

                if (option.value !== '') {
                    areaContent += '<div class="selected-option ' + optionClasses + '" ' + (optionCss !== '' ? 'style="' + optionCss + '"' : '') + '>' + self.selectedOptionRender(option) + (self.multiple ? '<a class="remove-selected-option" data-index="' + i + '"><i class="fa fa-times"></i></a>' : '') + '</div>';
                }

            }
        } else {
            let [, option] = selectedOptions[0];

            let optionClasses = '';
            if (option.getAttribute('class') !== null) {
                dropDownArea.addClass(option.getAttribute('class'));
            }
            if (option.getAttribute('style') !== null) {
                dropDownArea.attr('style', option.getAttribute('style'));
            }

            areaContent += '<div class="selected-option">' + self.selectedOptionRender(option) + '</div>';
        }

    } else {
        areaContent += this.defaultPromptText;
    }

    dropDownArea.find('.selected-options').html(areaContent);
    this.dropDownObject.checkWrapperWidth();

};

MySelectBox.prototype.selectValue = function (optionIndex) {

    let optionsTarget = this.dropDownWrapper.find('.my-select-box-options');

    if (!this.multiple) {
        let lastOptionIndex = Object.keys(this.selectedOptions).pop();
        optionsTarget.find('.select-option-' + lastOptionIndex + '').removeClass('selected');
        delete this.selectedOptions[lastOptionIndex];
    }

    if (this.selectedOptions[optionIndex] === undefined) {
        this.selectedOptions[optionIndex] = this.options[optionIndex];
        optionsTarget.find('.select-option-' + optionIndex + '').addClass('selected');
    } else {
        if (this.multiple) {
            delete this.selectedOptions[optionIndex];
            optionsTarget.find('.select-option-' + optionIndex + '').removeClass('selected');
        }
    }

    this.dropDownObject.hide();
    this.updateSelect();
    this.renderSelectedOptions();

    this.selectBox.trigger('change');

};

MySelectBox.prototype.searchByTerm = function (searchTerm, callback) {

    if (this.ajaxHandleIsSet()) {
        this.loadAjaxData(searchTerm, function (result) {
            if (result) {
                callback(result);
            }
        });
    } else {
        let result = [];

        let re = new RegExp(searchTerm);

        this.optionsTexts.forEach(function (text, i) {
            if (re.exec(text) || text.toLowerCase().includes(searchTerm.toLowerCase())) {
                result.push(i);
            }
        });
        callback(result);
    }

};

MySelectBox.prototype.filterOptions = function (searchTerm) {

    let optionsTarget = this.dropDownWrapper.find('.my-select-box-options');
    let self = this;

    this.searchByTerm(searchTerm, function (result) {
        if (isDefined(result)) {
            if (self.ajaxHandleIsSet()) {
                self.renderOptions();
                self.renderSelectedOptions();
            } else {
                optionsTarget.find('.select-option').css({
                    'display': 'none'
                });

                if (result.length) {
                    this.dropDownWrapper.find('.not-found').show();
                    result.forEach(function (index) {
                        optionsTarget.find('.select-option-' + index + '').css({
                            'display': 'block'
                        });
                    });
                } else {
                    this.dropDownWrapper.find('.not-found').hide();
                }
            }
        }
    });

};

MySelectBox.prototype.selectOptionsByTerm = function (term) {

    let self = this;
    if (this.multiple) {
        this.searchByTerm(term, function (result) {
            if (isDefined(result)) {
                result.forEach(function (index) {
                    self.selectValue(index);
                });
            }
        });
    } else {
        console.error('Selectbox is not multiple');
    }

};

MySelectBox.prototype.renderOptions = function () {

    let optionsTarget = this.dropDownWrapper.find('.my-select-box-options');

    optionsTarget.html('');
    let self = this;

    this.options.forEach(function (option, i) {

        let optionElem = $(self.optionRender(option));
        let optionParent = option.parentNode;
        let optionsGroup = null;

        if (optionParent.nodeName.toLowerCase() !== 'select') {
            let label = optionParent.getAttribute('label');
            let upperParent = optionParent.parentNode;

            optionsGroup = optionsTarget.find('.select-options-group-' + webalize(label) + '');
            let optionsUpperGroup = null;
            if (upperParent.nodeName.toLowerCase() !== 'select') {
                optionsUpperGroup = optionsTarget.find('.select-options-group-' + webalize(upperParent.getAttribute('label')) + '');
            }

            if (!optionsGroup.length) {
                optionsGroup = $('<div class="select-options-group select-options-group-' + webalize(label) + '"><label>' + label + '</label></div>');
                if (optionsUpperGroup !== null) {
                    optionsUpperGroup.append(optionsGroup);
                } else {
                    optionsTarget.append(optionsGroup);
                }
            }
        }

        optionElem.data('index', i);
        optionElem.data('value', option.value);
        if (option.getAttribute('class') != null) {
            optionElem.attr('class', option.getAttribute('class'));
        }
        if (option.getAttribute('style') != null) {
            optionElem.attr('style', option.getAttribute('style'));
        }
        optionElem.addClass('select-option');
        optionElem.addClass('select-option-' + i + '');

        if (option.selected) {
            optionElem.addClass('selected');
        }

        if (optionsGroup !== null) {
            optionsGroup.append(optionElem);
        } else {
            optionsTarget.append(optionElem);
        }
    });

};

MySelectBox.prototype.init = function () {

    if (isDefined(this.selectBox.data("instance"))) {
        return;
    }

    let defaultStyles = this.selectBox.attr('style');

    this.selectBox.css({
        'display': 'none'
    });

    this.selectBox.wrap('<div class="inp-wrap inp-select-wrap"></div>');

    this.selectBox.parent().append(`
        <div class="drop-down-wrap my-select-box">
            <div class="drop-down-area">${this.dropDownAreaRender()}</div>
            <div class="drop-down-body select-options">
                <div class="drop-down-content"></div>
            </div>
        </div>
    `);

    this.dropDownWrapper = this.selectBox.parent().find('.drop-down-wrap');

    if (this.selectBox.hasAttr('class')) {
        this.selectBox.parent().addClass(this.selectBox.attr('class'));
    }

    let self = this;
    if (this.search) {
        this.dropDownWrapper.find('.drop-down-content').append(`
            <div class="search-area">
                <input type="text" placeholder="Zadejte hledaný výraz"/>
            </div>
            <div class="not-found" style="display: none;">Pro hledný výraz nebylo nic nalezeno</div>
        `);

        let timer;
        this.dropDownWrapper.find('.drop-down-content').find(".search-area input").on("keyup", function (e) {
            clearTimeout(timer);
            let searchTerm = $(this).val();
            timer = setTimeout(function () {
                if (searchTerm.length >= self.searchMinLength) {
                    self.filterOptions(searchTerm);
                }
            }, 500);
        });

    }

    this.dropDownWrapper.find('.drop-down-content').append('<div class="my-select-box-options"></div>');

    if (this.multiple) {
        this.dropDownWrapper.addClass('multiple');
    }

    let dropDown = new DropDown(this.dropDownWrapper);
    dropDown.init();

    if (isDefined(defaultStyles)) {
        this.dropDownWrapper.attr('style', defaultStyles);
    }

    this.setDropDownObject(dropDown);
    this.renderOptions();
    this.renderSelectedOptions();

    this.selectBox.data("instance", this);
};

$(document).on("click", '.my-select-box .select-option', function (e) {
    e.preventDefault();
    if ($(this).closest('.inp-select-wrap').find('select').length) {
        let instance = $(this).closest('.inp-select-wrap').find('select').data('instance');
        instance.selectValue($(this).data('index'));
    }
});

$(document).on("click", '.my-select-box .remove-selected-option', function (e) {
    e.preventDefault();
    let instance = $(this).closest('.inp-select-wrap').find('select').data('instance');
    instance.selectValue($(this).data('index'));
});

const TextBoxWithPredefinedSelectionValues = function (input) {

    let textBox = input;
    let dropDownWrapper = null;
    let dropDownObject;
    let options = [];
    let dataList;

    if (input.hasAttr('list')) {

        dataList = $(document).find('#' + input.attr('list'));
        let dataListOptions = dataList.get(0).options;

        input.removeAttr('list');

        Array.from(dataListOptions).forEach(
            function (element, key, array) {
                options[key] = array[key];
            }
        );

    }

    let settings = {
        search: false,
        optionRender: function (option) {
            return '<div class="flex-box flex-align-justify"><span>' + option.value + '</span></div>';
        },
        searchMinLength: 3,
        ajaxHandle: null
    };

    Object.defineProperties(this, {
        textBox: {
            get: function () {
                return textBox;
            }
        },
        dropDownWrapper: {
            get: function () {
                return dropDownWrapper;
            },
            set: function (dropDownWrapperObj) {
                if (isObject(dropDownWrapperObj)) {
                    dropDownWrapper = dropDownWrapperObj;
                }
            }
        },
        dropDownObject: {
            get: function () {
                return dropDownObject;
            }
        },
        dataList: {
            get: function () {
                return dataList;
            }
        },
        search: {
            get: function () {
                return settings.search;
            },
            set: function (search) {
                if (isBoolean(search)) {
                    settings.search = search;
                }
            }
        },
        optionRender: {
            get: function () {
                return settings.optionRender;
            },
            set: function (optionRender) {
                if (isFunction(optionRender)) {
                    settings.optionRender = optionRender;
                }
            }
        },
        options: {
            get: function () {
                return options;
            }
        },
        searchMinLength: {
            get: function () {
                return settings.searchMinLength;
            },
            set: function (searchMinLength) {
                settings.searchMinLength = parseInt(searchMinLength);
            }
        },
        ajaxHandle: {
            set: function (ajaxHandle) {
                if (isFunction(ajaxHandle)) {
                    settings.ajaxHandle = ajaxHandle;
                }
            }
        },
    });

    this.loadAjaxData = function (callback) {
        let self = this;
        settings.ajaxHandle(function (jsonOptions) {

            if (isDefined(jsonOptions)) {

                self.options.forEach(function (option) {
                    option.remove();
                });

                if (Object.entries(jsonOptions).length) {
                    dropDownWrapper.find('.not-found').hide();
                    for (let value of Object.values(jsonOptions)) {
                        let option = $('<option value="' + value + '"/>');
                        self.dataList.append(option);
                    }
                } else {
                    dropDownWrapper.find('.not-found').show();
                }

                options = [];

                let dataListOptions = self.dataList.get(0).options;
                Array.from(dataListOptions).forEach(
                    function (element, key, array) {
                        options[key] = array[key];
                    }
                );

                callback(true);
            }
        });
    };

    this.ajaxHandleIsSet = function () {
        return settings.ajaxHandle != null;
    };

    this.setDropDownObject = function (dropDownObj) {
        dropDownObject = dropDownObj;
    };

};

TextBoxWithPredefinedSelectionValues.prototype.selectValue = function (optionIndex) {
    let selectedOption = this.options[optionIndex];

    this.textBox.val(selectedOption.value);
    this.dropDownObject.hide();
    this.textBox.trigger('change');
};

TextBoxWithPredefinedSelectionValues.prototype.loadOptions = function (callback) {

    if (this.ajaxHandleIsSet()) {
        this.loadAjaxData(function () {
            callback();
        });
    } else {
        callback();
    }

};

TextBoxWithPredefinedSelectionValues.prototype.renderOptions = function () {

    let optionsTarget = this.dropDownWrapper.find('.my-select-box-options');
    let self = this;

    this.loadOptions(function () {

        optionsTarget.html('');

        if (self.options.length > 0) {
            self.options.forEach(function (option, i) {

                let optionElem = $(self.optionRender(option));

                optionElem.data('index', i);
                optionElem.data('value', option.value);
                if (option.getAttribute('class') != null) {
                    optionElem.attr('class', option.getAttribute('class'));
                }
                if (option.getAttribute('style') != null) {
                    optionElem.attr('style', option.getAttribute('style'));
                }
                optionElem.addClass('select-option text-option');
                optionElem.addClass('select-option-' + i + '');

                optionsTarget.append(optionElem);
            });

            self.dropDownWrapper.find('.drop-down-body').css('display', 'block');

        } else {
            self.dropDownWrapper.find('.drop-down-body').css('display', 'none');
        }

    });

};

TextBoxWithPredefinedSelectionValues.prototype.init = function () {

    if (isDefined(this.textBox.data("instance"))) {
        return;
    }

    let defaultStyles = this.textBox.attr('style');

    this.textBox.wrap('<div class="inp-wrap inp-select-wrap"><div class="drop-down-wrap my-select-box"><div class="drop-down-area"></div></div></div>');
    this.dropDownWrapper = this.textBox.closest('.drop-down-wrap');

    this.dropDownWrapper.closest('.drop-down-wrap').append(`
        <div class="drop-down-body select-options">
            <div class="drop-down-content"></div>
        </div>
    `);

    /*
    let self = this;
    if (this.search) {
        this.dropDownWrapper.find('.drop-down-content').append(`
            <div class="search-area">
                <input type="text" placeholder="Zadejte hledaný výraz"/>
            </div>
            <div class="not-found" style="display: none;">Pro hledný výraz nebylo nic nalezeno</div>
        `);

        let timer;
        this.dropDownWrapper.find('.drop-down-content').find(".search-area input").on("keyup", function (e) {
            clearTimeout(timer);
            let searchTerm = $(this).val();
            timer = setTimeout(function () {
                if (searchTerm.length >= self.searchMinLength) {
                    self.filterOptions(searchTerm);
                }
            }, 500);
        });

    }*/

    this.dropDownWrapper.find('.drop-down-content').append('<div class="my-select-box-options"></div>');

    let dropDown = new DropDown(this.dropDownWrapper);
    dropDown.init();

    if (isDefined(defaultStyles)) {
        this.dropDownWrapper.attr('style', defaultStyles);
    }

    this.setDropDownObject(dropDown);
    this.renderOptions();

    let self = this;
    this.textBox.on("keyup", function () {
        self.dropDownObject.hide();
    });

    this.textBox.data("instance", this);
};

$(document).on("click", '.my-select-box .text-option', function (e) {
    e.preventDefault();
    let instance = $(this).closest('.inp-select-wrap').find('input[type="text"]').data('instance');
    instance.selectValue($(this).data('index'));
});

(function ($) {

    $.fn.isVisible = function () {
        let elem = $(this);

        if (elem.is('body')) {
            return true;
        }
        if (!elem.is(':visible')) {
            return false;
        }
        if (elem.css('visibility') === "hidden") {
            return false;
        }
        if (parseInt(elem.css('opacity')) === 0) {
            return false;
        }
        if (elem.width() === 0 || elem.height === 0) {
            return false;
        }
        if (!elem.parent().isVisible()) {
            return false;
        }
        return true;
    };

    $.fn.hasAttr = function (name) {
        return this.attr(name) !== undefined;
    };

    $.fn.customRadioFields = function () {

        $(this).each(function () {

            if (!$(this).data("processed")) {

                if ($(this).closest(".inp-radio-wrap").length) {

                    let input = null;
                    if ($(this).hasClass('inp-radio-wrap')) {
                        input = $(this).find('input[type="radio"]');
                    } else {
                        input = $(this);
                    }

                    let container = $(this).closest(".inp-radio-wrap");
                    let field = container.find(".radio-field");

                    if (!field.find(".checked-disabled").length) {
                        field.prepend('<i class="far fa-circle checked-disabled displ-none"></i>');
                    }
                    if (!field.find(".unchecked-disabled").length) {
                        field.prepend('<i class="fas fa-circle unchecked-disabled displ-none"></i>');
                    }
                    if (!field.find(".checked").length) {
                        field.prepend('<i class="fas fa-circle checked displ-none"></i>');
                    }
                    if (!field.find(".unchecked").length) {
                        field.prepend('<i class="far fa-circle unchecked"></i>');
                    }

                    checkRadioField(input, input.prop("checked"));

                    if (!input.prop("disabled")) {
                        container.on("click", function (e) {

                            if ($(e.target).is("input")) {
                                input.prop("checked", !input.prop("checked"));
                            }

                            let checked = input.prop("checked");

                            if (checked) {
                                input.prop("checked", false);
                                checked = false;
                            } else {
                                input.prop("checked", true);
                                checked = true;
                            }

                            checkRadioField(input, checked);
                            input.trigger('change');

                        });
                    }
                }

                $(this).data("processed", true);
            }
        });
    };

    $.fn.customCheckboxes = function () {

        $(this).each(function () {

            if (!$(this).data("processed")) {

                if ($(this).closest(".inp-checkbox-wrap").length) {

                    let input = null;

                    if ($(this).hasClass('inp-checkbox-wrap')) {
                        input = $(this).find('input[type="checkbox"]');
                    } else {
                        input = $(this);
                    }

                    let container = $(this).closest(".inp-checkbox-wrap");
                    let field = container.find(".checkbox-field");

                    if (!field.find(".checked-disabled").length) {
                        field.prepend('<i class="fas fa-check-square checked-disabled displ-none"></i>');
                    }
                    if (!field.find(".unchecked-disabled").length) {
                        field.prepend('<i class="far fa-square unchecked-disabled displ-none"></i>');
                    }
                    if (!field.find(".checked").length) {
                        field.prepend('<i class="fas fa-check-square checked displ-none"></i>');
                    }
                    if (!field.find(".unchecked").length) {
                        field.prepend('<i class="far fa-square unchecked"></i>');
                    }

                    checkCheckboxField(input, input.prop("checked"));

                    if (!input.prop("disabled")) {
                        container.on("click", function (e) {

                            if ($(e.target).is("input")) {
                                input.prop("checked", !input.prop("checked"));
                            }
                            let checked = input.prop("checked");
                            if (checked) {
                                input.prop("checked", false);
                                checked = false;
                            } else {
                                input.prop("checked", true);
                                checked = true;
                            }
                            checkCheckboxField(input, checked);
                            input.trigger('change');

                        });
                    }
                }
                $(this).data("processed", true);

            }
        });
    };

})(jQuery);